import './no-results.scss';

import * as offers from '../../core/selectors/offers';
riot.tag2('offers-no-results', '<p>{getLabel(\'labels.noResults.textMessage\')}</p> <button class="no-results-button" each="{cta in getLabel(\'ctas.noResults\')}" onclick="{clickHandler}"> {cta.name} </button>', '', 'show="{!hasOffers}"', function(opts) {

    const self = this;

    self.mixin('bus');
    self.mixin('redux');

    self.subscribe(offers[self.opts.offerType]);

    self.hasOffers = true;

    function clickHandler(e) {
      window.open(e.item.cta.url, e.item.cta.target || '_blank');
    }

    function hasOffersHandler(model = null) {
      if (Object.keys(self.offersByModel).length > 0 && self.offersByModel.constructor === Object) {
        let offersCount = 0;
        Object.keys(self.offersByModel).forEach((key) => {
          // All vehicles comes in model.newValue when this option is selected in the dropdown
          // ModelGroupName is the key for the global special offers (Military, College offers)
          if (model && model.newValue !== 'All Vehicles' && key !== 'ModelGroupName') {
            if (model.newValue === key) {
              offersCount += self.offersByModel[key].length;
            }
          } else {
            offersCount += self.offersByModel[key].length;
          }
        });

        self.hasOffers = offersCount > 0;
      } else {
        self.hasOffers = false;
      }
      self.update();
    }

    self.bus.on(self.bus.EVENTS.DATA.DATA_LOADED, () => {
      hasOffersHandler();
    });

    self.bus.on(self.bus.EVENTS.MODEL.CHANGE, (model) => {
      hasOffersHandler(model);
    });

    self.clickHandler = clickHandler;
    self.hasOffers = hasOffersHandler;
});
